export default {
  TOOLTIP_ENABLED: '@tooltip/TOOLTIP_ENABLED',
  TOOLTIP_DISABLED: '@tooltip/TOOLTIP_DISABLED',
};
